export const isWindowObjectAvailable = (): boolean => {
	return typeof window !== 'undefined';
};
